import React from 'react';
import cn from 'classnames';

import * as styles from './Text.module.css';

const Text = ({ text, className, style }) => {
  // Remove inline styles from string of text
  const textWithoutInlineStyles = text.replace(/style="[^"]*"/g, '');

  const textToHtml = { __html: textWithoutInlineStyles };

  return (
    <div
      className={cn(styles.root, className)}
      style={style}
      dangerouslySetInnerHTML={textToHtml}
    />
  );
};

export default Text;
